import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { SessionService } from '../services/session.service';
import { tap } from 'rxjs/operators';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {

  const authService = inject(AuthService);
  const sessionService = inject(SessionService);
  const toastr = inject(ToastrService);

  return next(req).pipe(
    tap(
      (event) => {
        // if (event.type === 4) {  // 4 means HttpResponse  ==> also can be achieved like this
        if (event instanceof HttpResponse) { 
          if (event.status === 401) {
            
            // authService.logOutWithoutCall();
          }

          // if (!event.url?.includes('heartbeat') && !event.url?.includes('cookie') && !event.url?.includes('login') && !event.url?.includes('ipify')&& !event.url?.includes('logout')) {
            
          //   // if(authService.JWTToken)
          //   //   {
          //   //     // sessionService.autoLogOut(15 * 60 * 1000);

          //   //   }
          // }
        }
      },
      (error) => {
        if (error.status === 403 || error.status === 401) {
          // authService.logOut();
        }

        if (error.status === 429) {
          toastr.warning('Too many requests');
        }
      }
    )
  );
};
